export default __webpack_public_path__ + "static/media/blind-figma.cf7bf9b1.svg";